export default "__VITE_ASSET__DVbWJ6Rq__"